/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */
const bench = (name) => {
    return {
        name: name,
        start: Date.now(),
        end: function (flag = 'report', max = 16) {
            let total = Date.now() - this.start
            if (flag === 'warn' && total > max) {
                console.warn(name, 'took', total, 'ms')
            }
            else if (flag === 'report') {
                console.log(name, 'took', total, 'ms')
            }
        }
    }
}

export default bench
